var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-expansion',{attrs:{"components":_vm.customComponents,"data":_vm.valueComputed,"flat":""},on:{"save-required":function($event){return _vm.$emit('save-required')}},model:{value:(_vm.valueComputed),callback:function ($$v) {_vm.valueComputed=$$v},expression:"valueComputed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }